module.exports = __webpack_public_path__ + "img/CTN20_white_transparent_anos.99ac7af9.png";